import type { SxProps, Theme } from '@mui/material';

export const getFilterBarSlotSx = (loading?: boolean): SxProps<Theme> => ({
  pointerEvents: loading ? 'none' : 'auto',
});

export const contentSlotSx: SxProps<Theme> = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  minHeight: 0,
  overflow: 'hidden',
};
